/**
 * Medical degree types
 */
export enum MedicalDegree {
  MBBS = "mbbs",
  MASTERS = "masters",
  PHD = "phd",
  DIPLOMA = "diploma",
  HIGHER_DIPLOMA = "higher_diploma",
  FELLOWSHIP = "fellowship",
  ARAB_BOARD_FELLOW = "arab_board_fellow",
  IRAQI_BOARD_FELLOW = "iraqi_board_fellow",
  IRAQI_BOARD = "iraqi_board",
  ARAB_BOARD = "arab_board",
  EGYPTIAN_BOARD = "egyptian_board",
  JORDANIAN_BOARD = "jordanian_board",
  EUROPEAN_BOARD = "european_board",
  ROYAL_COLLEGE_EDINBURGH_FELLOWSHIP = "royal_college_edinburgh_fellowship",
  /**
   * Legacy — meant "Arab OR Iraqi board" before those were split into the
   * values above. Doctors registered earlier still carry it, so it stays here
   * so their record still renders, but it is excluded from
   * MEDICAL_DEGREE_VALUES and can never be picked again.
   */
  BOARD_CERTIFICATION = "board_certification"
}

/**
 * Degrees a doctor can choose, in dropdown order.
 * Excludes the retired BOARD_CERTIFICATION.
 */
export const MEDICAL_DEGREE_VALUES = Object.values(MedicalDegree).filter(
  (degree) => degree !== MedicalDegree.BOARD_CERTIFICATION
);

/**
 * Human-readable labels for medical degrees
 */
export const MEDICAL_DEGREE_LABELS: Record<MedicalDegree, string> = {
  [MedicalDegree.MBBS]: "MBBS (Bachelor of Medicine, Bachelor of Surgery)",
  [MedicalDegree.MASTERS]: "Master's Degree",
  [MedicalDegree.PHD]: "PhD (Doctor of Philosophy)",
  [MedicalDegree.DIPLOMA]: "Diploma",
  [MedicalDegree.HIGHER_DIPLOMA]: "Higher Diploma",
  [MedicalDegree.FELLOWSHIP]: "Fellowship",
  [MedicalDegree.ARAB_BOARD_FELLOW]: "Fellow of the Arab Board of Health Specializations",
  [MedicalDegree.IRAQI_BOARD_FELLOW]: "Fellow of the Iraqi Board of Medical Specializations",
  [MedicalDegree.IRAQI_BOARD]: "Iraqi Board",
  [MedicalDegree.ARAB_BOARD]: "Arab Board",
  [MedicalDegree.EGYPTIAN_BOARD]: "Egyptian Board",
  [MedicalDegree.JORDANIAN_BOARD]: "Jordanian Board",
  [MedicalDegree.EUROPEAN_BOARD]: "European Board",
  [MedicalDegree.ROYAL_COLLEGE_EDINBURGH_FELLOWSHIP]: "Fellowship of the Royal College of Edinburgh",
  [MedicalDegree.BOARD_CERTIFICATION]: "Board Certification"
};
